import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { NavLink } from 'react-router-dom';
import { withUIETheme } from '../uietheme/withUIETheme';
const MenuItem = ({ uieTheme, to, children }) => {
    const style = {
        paddingBottom: '0.2rem',
        marginLeft: 0,
        paddingLeft: 0,
        listStyle: 'none',
        '> a': {
            textDecoration: 'none',
            ...uieTheme.fontStyles.base,
            color: uieTheme.colors.textMenuItem,
            fontSize: uieTheme.fontSizes.text,
        },
        '> a:visited': {
            textDecoration: 'none',
            ...uieTheme.fontStyles.base,
        },
        '> a.active': {
            fontWeight: 'bold',
        },
    };
    return (React.createElement(FelaComponent, { style: style, as: "li" },
        React.createElement(NavLink, { to: to, "data-testid": to }, children)));
};
export default withUIETheme(MenuItem);
//# sourceMappingURL=MenuItem.js.map